import { useMatchesData } from "~/useMatchesData";
import { useLocation } from "@remix-run/react";
import type { PageStaticData } from "~/api/get_static_data.server";
export default function Datenschutz() {
  const location = useLocation();
  //@ts-ignore
  const data: {
    item: PageStaticData;
    filterData: any;
  } = useMatchesData("/", location.pathname);
  return (
    <div className="mx-auto flex flex-col justify-center px-4 pb-10 md:px-1">
      <div className="flex items-center justify-center pb-8 md:max-w-6xl lg:mx-auto">
        <div className="mt-8 w-full">
          <div className="w-4/6">
            <div
              className="text-base font-normal leading-6 "
              dangerouslySetInnerHTML={{
                __html: data.item.body,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
